import { useEffect } from 'react';
import router from 'next/router';

import { useStoreDispatch, useStoreSelector } from 'store/hooks/storeHooks';
import { setIsHeaderVisible } from 'store/slice/pageLayoutSlice';

export const usePutBackHeaderOnPageChange = () => {
  const storeDispatch = useStoreDispatch();
  const { isHeaderVisible } = useStoreSelector((state) => state.pageLayout);

  useEffect(() => {
    const handleRouteChangeStart = () => {
      if (!isHeaderVisible) {
        storeDispatch(setIsHeaderVisible(true));
      }
    };

    router.events.on('routeChangeStart', handleRouteChangeStart);
    return () => {
      router.events.off('routeChangeStart', handleRouteChangeStart);
    };
  });
};
